<button class="button" v-on:click.prevent="action" :class="classObject" :disabled="disabled" :title="buttonText"><slot></slot></button>